import React from 'react'
import { Redirect, Route, useLocation } from 'react-router-dom'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { REGEX_PASSPORT_PAY } from 'constants/passport'

const ClientRoute = ({ component: ComposedComponent, authenticated, roles, ...rest }) => {
  const location = useLocation()
  const redirectTo = REGEX_PASSPORT_PAY.test(location.pathname)
    ? `/login?redirectTo=${location.pathname + location.search}`
    : `/login${location.search}`

  return (
    <Route
      exact
      {...rest}
      render={() =>
        authenticated && roles.includes('client') ? (
          <ComposedComponent />
        ) : (
          <Redirect exact strict={true} to={redirectTo} />
        )
      }
    />
  )
}

ClientRoute.propTypes = {
  authenticated: PropTypes.bool.isRequired,
  component: PropTypes.object.isRequired,
  roles: PropTypes.array.isRequired,
}

const mapStateToProps = ({ auth }) => ({
  authenticated: auth.authenticated,
  roles: auth.user.roles,
})

export default connect(mapStateToProps)(ClientRoute)
